import { render, staticRenderFns } from "./CreateGptProfile.vue?vue&type=template&id=23933fac&scoped=true"
import script from "./CreateGptProfile.vue?vue&type=script&lang=js"
export * from "./CreateGptProfile.vue?vue&type=script&lang=js"
import style0 from "./CreateGptProfile.vue?vue&type=style&index=0&id=23933fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23933fac",
  null
  
)

export default component.exports